import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import adminApi from '../clients/AdminClient';
import { SimulatorAssignmentResponse } from '../models/responseBodies/SimulatorAssignmentResponse';

function SimulatorAssignments() {
    const { location } = useParams<{ location: string }>();
    const [assignments, setAssignments] = useState<SimulatorAssignmentResponse[] | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!location) return;
            try {
                const response = await adminApi.GetSimulatorAssignments(location);
                setAssignments(response);
            } catch (error) {
                console.error("Error fetching simulator assignments:", error);
            }
        };

        fetchData();

        const intervalId = setInterval(fetchData, 10000);

        return () => clearInterval(intervalId);
    }, [location]);

    // Formats the simulator name to remove the "Sim " prefix
    function formatSimulatorName(simulator: string): string {
        return simulator.includes('Sim ') ? simulator.replace('Sim ', '') : simulator;
    }

    // Gets the group number from the simulator name to show 1-9 in one column, 10-19 in another, etc.
    function getGroupNumber(simulator: string): number {
        const match = simulator.match(/\d+/);
        if (!match) return 0;
        const number = parseInt(match[0], 10);
        return Math.floor(number / 10);
    }

    const eSportsAssignments = assignments?.filter(x => x.simulatorType === "Esports") || [];
    const chunkedAssignmentsESports: SimulatorAssignmentResponse[][] = [];

    // Chunks the assignments into groups of 10
    for (let i = 0; i < eSportsAssignments.length; i++) {
        const groupNumber = getGroupNumber(eSportsAssignments[i].simulator);
        if (!chunkedAssignmentsESports[groupNumber]) {
            chunkedAssignmentsESports[groupNumber] = [];
        }
        chunkedAssignmentsESports[groupNumber].push(eSportsAssignments[i]);
    }

    const fullMotionAssignments = assignments?.filter(x => x.simulatorType === "FullMotion") || [];
    const chunkedAssignmentsFullMotion: SimulatorAssignmentResponse[][] = [];

    for (let i = 0; i < fullMotionAssignments.length; i++) {
        const groupNumber = getGroupNumber(fullMotionAssignments[i].simulator);
        if (!chunkedAssignmentsFullMotion[groupNumber]) {
            chunkedAssignmentsFullMotion[groupNumber] = [];
        }
        chunkedAssignmentsFullMotion[groupNumber].push(fullMotionAssignments[i]);
    }
  
    return (
        <main>
            <div style={{ height: '100vh', fontSize: 25 }}>
                <article className="content px-4">
                    <div className="text-center">
                        <img src='/logo.png' alt="Logo" style={{ width: `20%`, marginTop: '8pt' }} />
                    </div>

                    <div className="container" style={{ background: 'white', padding: '20px', color: 'black', minWidth: '80%', minHeight: '80vh', marginTop: '20pt' }}>
                        <h3>Esports</h3>
                        <div className="row">
                            {chunkedAssignmentsESports.map((group, groupIndex) => (
                                <div className="mb-4 col" key={groupIndex}>
                                    <table className="table table-striped" style={{ color: 'black' }}>
                                        <tbody>
                                            {group.map((result, index) => (
                                                <tr key={index}>
                                                    <td>{formatSimulatorName(result.simulator)}</td>
                                                    <td>{result.driver}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                        <h3>Pro sims</h3>
                        <div className="row">
                            {chunkedAssignmentsFullMotion.map((group, groupIndex) => (
                                <div className="mb-4 col" key={groupIndex}>
                                    <table className="table table-striped" style={{ color: 'black' }}>
                                        <tbody>
                                            {group.map((result, index) => (
                                                <tr key={index}>
                                                    <td>{formatSimulatorName(result.simulator)}</td>
                                                    <td>{result.driver}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                    </div>
                </article>
            </div>
        </main>
    );
  }
  
  export default SimulatorAssignments;